import { Button } from "@/components/Buttons/index";
import { SingleCheckboxField, ErrorMessage } from "@/components/Form/Parts/index";
import styles from "@/styles/Form.module.scss";
import modalStyles from "@/styles/Modal.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import Link from "next/link";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { useMemo } from "react";
import { useAuthUserQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const schema = y.object().shape({
  terms: y.boolean().oneOf([true], "規約に同意してください。")
});
export default function TermAgreementForm(_ref) {
  var _errors$termsAd, _errors$terms_mail, _errors$terms;
  let {
    terms,
    onSubmit,
    agreementError
  } = _ref;
  const {
    formState,
    register,
    handleSubmit,
    errors
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    isDirty,
    isValid
  } = formState;
  const {
    data
  } = useAuthUserQuery({
    variables: {}
  });
  const {
    receiveAdvertisingMailType
  } = (data === null || data === void 0 ? void 0 : data.user) || {};
  const requiredTerms = useMemo(() => {
    return terms.filter(term => term.required);
  }, [terms]);
  const adTerm = useMemo(() => {
    if (terms) {
      const term = terms.find(term => term.id_key === "ad");
      if (term) {
        return {
          link: term.current_revision.url,
          value: term.current_revision.unique_key
        };
      }
    }
    return null;
  }, [terms]);
  const mailTerm = useMemo(() => {
    if (terms) {
      const key = "spoox_mail";
      const term = terms.find(term => term.id_key === key);
      if (term) {
        return {
          link: term.current_revision.url,
          value: term.current_revision.unique_key
        };
      }
    }
    return null;
  }, [terms]);
  const showMailTerm = useMemo(() => {
    if ((receiveAdvertisingMailType == 0 || receiveAdvertisingMailType == 1) && mailTerm) {
      return true;
    }
    return false;
  }, [mailTerm, receiveAdvertisingMailType]);
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h3", {
        children: "\u898F\u7D04\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F"
      }), /*#__PURE__*/_jsx("p", {
        className: modalStyles.lead,
        children: "\u5229\u7528\u898F\u7D04\u3092\u518D\u5EA6\u304A\u8AAD\u307F\u3044\u305F\u3060\u304D\u3001\u300C\u540C\u610F\u3059\u308B\u300D\u306B\u30C1\u30A7\u30C3\u30AF\u3092\u3057\u3066\u304B\u3089\u300C\u540C\u610F\u3059\u308B\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
      }), adTerm && /*#__PURE__*/_jsx("fieldset", {
        className: `${styles.basicFieldset} ${styles.vwScale} ${styles.termAgreementForm}`,
        children: /*#__PURE__*/_jsx(SingleCheckboxField, {
          ref: register,
          title: "\u5E83\u544A\u306B\u304A\u3051\u308B\u30C7\u30FC\u30BF\u5229\u7528\u306B\u3064\u3044\u3066\u306E\u78BA\u8A8D\u3068\u540C\u610F",
          name: "termsAd",
          defaultChecked: false,
          vwScale: true,
          label: /*#__PURE__*/_jsxs("p", {
            className: styles.terms,
            children: ["\u672C\u30B5\u30FC\u30D3\u30B9\u3067\u306F\u5229\u7528\u8005\u306B\u540C\u610F\u3044\u305F\u3060\u3044\u305F\u4E0A\u3067\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u60C5\u5831\u3092\u53CE\u96C6\u3057\u3001\u5E83\u544A\u914D\u4FE1\u306A\u3069\u306B\u6D3B\u7528\u3057\u3066\u3044\u307E\u3059\u3002", " ", /*#__PURE__*/_jsx(Link, {
              href: adTerm.link,
              target: "_blank",
              rel: "noopener noreferrer",
              children: "\u5E83\u544A\u306B\u304A\u3051\u308B\u30C7\u30FC\u30BF\u5229\u7528"
            }), "\u3092\u78BA\u8A8D\u306E\u4E0A\u3001\u540C\u610F\u3059\u308B"]
          }),
          error: (_errors$termsAd = errors.termsAd) === null || _errors$termsAd === void 0 ? void 0 : _errors$termsAd.message
        })
      }), showMailTerm && /*#__PURE__*/_jsxs("fieldset", {
        className: `${styles.basicFieldset} ${styles.vwScale} ${styles.termAgreementForm}`,
        children: [/*#__PURE__*/_jsx(SingleCheckboxField, {
          ref: register,
          title: "\u3054\u6848\u5185\u30E1\u30FC\u30EB\u3078\u306E\u540C\u610F",
          name: "termsMail",
          defaultChecked: false,
          vwScale: true,
          label: /*#__PURE__*/_jsxs("p", {
            className: styles.terms,
            children: ["\u672C\u30B5\u30FC\u30D3\u30B9\u304B\u3089\u306E\u3054\u6848\u5185\u30E1\u30FC\u30EB\u306E\u9001\u4ED8\u306B\u540C\u610F\u3059\u308B(\u8A73\u7D30\u306F", /*#__PURE__*/_jsx(Link, {
              href: mailTerm.link,
              target: "_blank",
              rel: "noopener noreferrer",
              children: "\u3053\u3061\u3089"
            }), ")"]
          }),
          error: (_errors$terms_mail = errors.terms_mail) === null || _errors$terms_mail === void 0 ? void 0 : _errors$terms_mail.message
        }), agreementError && /*#__PURE__*/_jsx(ErrorMessage, {
          msg: agreementError
        })]
      }), requiredTerms && requiredTerms.length > 0 && /*#__PURE__*/_jsx("fieldset", {
        className: `${styles.basicFieldset} ${styles.vwScale} ${styles.termAgreementForm}`,
        children: /*#__PURE__*/_jsx(SingleCheckboxField, {
          ref: register,
          name: "terms",
          title: "\u898F\u7D04\u306E\u78BA\u8A8D\u3068\u540C\u610F",
          defaultChecked: false,
          vwScale: true,
          label: /*#__PURE__*/_jsxs("p", {
            className: styles.terms,
            children: [requiredTerms.map(term => {
              var _term$current_revisio;
              if (term !== null && term !== void 0 && (_term$current_revisio = term.current_revision) !== null && _term$current_revisio !== void 0 && _term$current_revisio.url) {
                var _term$current_revisio2;
                return /*#__PURE__*/_jsx(Link, {
                  href: term === null || term === void 0 || (_term$current_revisio2 = term.current_revision) === null || _term$current_revisio2 === void 0 ? void 0 : _term$current_revisio2.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: term.display_name
                }, `${term.id_key}-link`);
              }
            }), "\u3092\u78BA\u8A8D\u306E\u4E0A\u3001\u540C\u610F\u3059\u308B"]
          }),
          error: (_errors$terms = errors.terms) === null || _errors$terms === void 0 ? void 0 : _errors$terms.message,
          required: true
        })
      }), /*#__PURE__*/_jsx(Button, {
        type: "submit",
        fillColor: true,
        large: true,
        disabled: !isDirty || !isValid,
        children: "\u540C\u610F\u3059\u308B"
      })]
    })
  });
}